import { render, staticRenderFns } from "./MainMenuBackground.vue?vue&type=template&id=2a51170e&"
import script from "./MainMenuBackground.vue?vue&type=script&lang=js&"
export * from "./MainMenuBackground.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports